import { Typography } from "@mui/material";
import GoogleLogo from "../../../styles/svg/Google__G__logo .svg";
import "./GoogleLogin.scss"; // Import the CSS file for styling
import {
  apiGoogleLogin,
} from "../../../services/apiGoogleAuth";

function GoogleLogin() { 

  function googleLogin() {
    apiGoogleLogin();
  }

  return (
    <div className="google-login-container">
      <Typography className="google-login-title mb-2">
        Plan Your Day with Ease
      </Typography>
      <Typography className="google-login-description">
        Effortlessly manage your personal to-dos and tasks from boards—all in
        one place. Organize everything with drag-and-drop simplicity and keep
        your planner private, tailored just for you.
      </Typography>
      <button className="google-signin-button" onClick={() => googleLogin()}>
        <img src={GoogleLogo} alt="Google Logo" className="google-logo" />
        Sign in with Google
      </button>
    </div>
  );
}

export default GoogleLogin;
